import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-administration-page',
    templateUrl: './administration-page.component.html',
    styleUrls: ['./administration-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdministrationPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
